import React from 'react';
import Icon from 'antd/lib/icon';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import Upload from 'antd/lib/upload';
import 'antd/lib/upload/style/index.css';
import ButtonAction from '../../components/utilities/ButtonAction';
var cardStyles = require('src/imports/styles/extend.card.scss');
var selfStyles = require('./styles.scss');
var FormFile = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("section", { className: selfStyles.formSection },
        React.createElement("h2", { className: cardStyles.header }, "Step 1"),
        React.createElement("h4", null, "Fill in the template Excel file for importing athletes. Please ensure that you save the file in the format \"Comma Separated Values (CSV)\"."),
        React.createElement("ul", { style: { listStyle: 'none' } },
            React.createElement("li", null,
                React.createElement("a", { href: '/files/import-athletes-template.csv', target: '_blank' },
                    React.createElement(Icon, { type: 'cloud-download' }),
                    " Template file")),
            React.createElement("li", null,
                React.createElement("a", { href: '/files/import-athletes-template-example.csv', target: '_blank' },
                    React.createElement(Icon, { type: 'cloud-download' }),
                    " Template file with pre-filled examples")),
            React.createElement("li", null,
                React.createElement("a", { href: '/files/Guide for Organizers to Import Athletes By Category.pdf', target: '_blank' },
                    React.createElement(Icon, { type: 'cloud-download' }),
                    " Guide to importing athletes with template file (PDF)")))),
    React.createElement("section", { className: selfStyles.formSection },
        React.createElement("h2", { className: cardStyles.header }, "Step 2"),
        React.createElement("h4", null, "Select the category to add athletes into."),
        React.createElement(Select, { size: 'large', style: { width: '100%' }, onChange: props.handleSelectCategory }, props.categories.map(function (c) { return (React.createElement(Select.Option, { key: c.id, value: c.id }, c.name)); }))),
    React.createElement("section", { className: selfStyles.formSection },
        React.createElement("h2", { className: cardStyles.header }, "Step 3"),
        React.createElement("h4", null, "Upload the CSV file."),
        React.createElement(Upload.Dragger, { name: 'uploadAthleteCsv', multiple: false, accept: '.csv', action: undefined, fileList: props.fileList, beforeUpload: function (file) {
                props.handleSelectFile(file);
                return false;
            }, onRemove: function () { return props.handleRemoveFile(); } },
            React.createElement("p", { className: 'ant-upload-drag-icon' },
                React.createElement(Icon, { type: 'inbox' })),
            React.createElement("p", { className: 'ant-upload-text' }, "Click or drag file to this area to upload"),
            React.createElement("p", { className: 'ant-upload-hint' }, "Upload an Excel file saved as \"Comma Separated Values (.csv)\" format")),
        React.createElement(ButtonAction, { width: '100%', isDisabled: !props.isFormValid },
            React.createElement("button", { onClick: props.handleUploadFile },
                React.createElement(Icon, { type: 'file-excel' }),
                " Submit the file"))))); };
export default FormFile;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthleteCsvPage/FormFile.tsx
// module id = 1213
// module chunks = 0